module.exports = __webpack_public_path__ + "static/media/bannerStageOG.cb3ce499.jpg";